module.exports = __webpack_public_path__ + "img/011c3de.png";